import React from 'react';

import { GoFormzLogoIcon } from '../icons/icons';

export interface InvalidPublicShareProps {
  errorMessage?: string;
}

export default function InvalidPublicShare(props: InvalidPublicShareProps) {
  return (
    <div className="form-editor invalid-public-share">
      <div className="header-wrapper">
        <div className="logo">
          <GoFormzLogoIcon />
        </div>
        <div className="header">
          <div className="item publicshare-title">
            <div>Turn your paper forms in to smart forms for mobile and web</div>
            <a href="https://www.goformz.com" target="_blank">
              Learn more
            </a>
          </div>
        </div>
      </div>
      <div className="public-share-invalid-wrapper">
        <div className="invalid-public-share-svg" />
        <div className="invalid-public-share-message">{props.errorMessage}</div>
      </div>
    </div>
  );
}
